var exports = {
  "kL": "xf0b3b88a--9fd266--container",
  "Kk": "xf0b3b88a--9fd266--icon",
  "Qq": "xf0b3b88a--9fd266--text",
};

module.exports = exports;
